export const alertTypes = {
  ERROR: 'ERROR',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  DEFAULT: 'DEFAULT',
  NO_CONTENT: 'NO_CONTENT'
};

export const alertClasses = {
  [alertTypes.ERROR]: 'error',
  [alertTypes.INFO]: 'info',
  [alertTypes.SUCCESS]: 'success',
  [alertTypes.DEFAULT]: 'default',
  [alertTypes.NO_CONTENT]: 'no_content'
};

export default alertTypes;
